export default __webpack_public_path__ + "static/media/005-cena.33a418b5.png";